import type { EvalRunStatus } from '@sbc/domain-models/agents';

import { Badge } from '@/components/ui/badge';

const VARIANT: Record<EvalRunStatus, 'secondary' | 'default' | 'destructive' | 'outline'> = {
  running: 'default',
  completed: 'secondary',
  failed: 'destructive',
  canceled: 'outline',
};

export function EvalRunStatusBadge({ status }: { status: EvalRunStatus }) {
  return <Badge variant={VARIANT[status]}>{status}</Badge>;
}
